import { useState } from "react";
import OfftakeComparisionCombined from "./OfftakeComparisionCombined";
import RetailComparisionCombined from "./RetailComparisionCombined";
import RealizationComparisionCombined from "./RealizationComparisionCombined";
import MsVahanCombined from "./MsVahanCombined";
import DashboardCharts from "../../../Components/Charts/DealerReviewVolumeChart";
import MomComparision from "./MomComparision";

const TopCollabaxSection = ({ show }) => {
  const [showDashboardCharts, setShowDashboardCharts] = useState(true);
  const [showMom, setShowMom] = useState(false);

  return (
    <div>
      {/* Toggles → screen only */}
      {!show && (
        <div className="flex justify-end my-2 gap-4">
          {/* Graph ↔ Table */}
          <label className="flex items-center cursor-pointer">
            <span className="text-sm mr-1">
              {showDashboardCharts
                ? "Show Tabular View"
                : "Show Graphical View"}
            </span>

            <input
              type="checkbox"
              className="hidden"
              checked={!showDashboardCharts}
              onChange={() => setShowDashboardCharts(!showDashboardCharts)}
            />

            <div className="w-10 h-5 bg-gray-300 rounded-full relative">
              <div
                className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                  !showDashboardCharts ? "translate-x-5" : "translate-x-0"
                }`}
              />
            </div>
          </label>

          {/* MoM toggle → only on charts */}
          {showDashboardCharts && (
            <label className="flex items-center cursor-pointer">
              <span className="text-sm mr-1">MoM Comparison</span>

              <input
                type="checkbox"
                className="hidden"
                checked={showMom}
                onChange={() => setShowMom(!showMom)}
              />

              <div className="w-10 h-5 bg-gray-300 rounded-full relative">
                <div
                  className={`w-5 h-5 bg-white rounded-md shadow-md transform transition-transform ${
                    showMom ? "translate-x-5" : "translate-x-0"
                  }`}
                />
              </div>
            </label>
          )}
        </div>
      )}

      {/* CONTENT */}
      {showDashboardCharts ? (
        showMom ? (
          <MomComparision />
        ) : (
          <section className="w-full">
            <DashboardCharts
              endpoint="dealer-review/volume_performance_offtake"
              Heading="Volume Performance Offtake"
            />

            <DashboardCharts
              endpoint="dealer-review/volume_performance_retail"
              Heading="Volume Performance Retail"
            />

            <DashboardCharts
              endpoint="dealer-review/realization_percentage_list"
              Heading="Realization as % of list price"
            />

            <DashboardCharts
              endpoint="dealer-review/ms_vaahan"
              Heading="District Wise TML Share (%)"
            />
          </section>
        )
      ) : (
        <section className="p-2 px-0 block md:grid md:grid-cols-2 gap-2">
          <OfftakeComparisionCombined />
          <RetailComparisionCombined />
          <RealizationComparisionCombined />
          <MsVahanCombined />
        </section>
      )}
    </div>
  );
};

export default TopCollabaxSection;
